// extracted by mini-css-extract-plugin
export default {"clientList":"clientlist_clientList__ppmkA","clientListPhone":"clientlist_clientListPhone__01b-w","clientListTablet":"clientlist_clientListTablet__wGD-8"};